import { DARK, LIGHT } from "../../constants/appConstants";

export default function InlineDropdown({
  label,
  value,
  open,
  onToggle,
  onClear,
  children,
  triggerBg,
  triggerColor,
  dark,
}) {
  const c = dark ? DARK : LIGHT;
  const lbl = {
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: ".08em",
    textTransform: "uppercase",
    color: c.textSecondary,
    marginBottom: 5,
    display: "block",
  };

  return (
    <div style={{ minWidth: 180, width: "fit-content" }}>
      <span style={lbl}>{label}</span>
      <button
        onClick={onToggle}
        data-entry-field="true"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "7px 14px",
          fontSize: 13,
          fontWeight: value ? 600 : 400,
          borderRadius: open ? "8px 8px 0 0" : "8px",
          cursor: "pointer",
          fontFamily: "inherit",
          border: `1px solid ${c.border}`,
          borderBottom: open ? "none" : `1px solid ${c.border}`,
          background: triggerBg || c.bgSecondary,
          color: triggerColor || c.textSecondary,
          width: "fit-content",
          minWidth: 180,
        }}
      >
        <span style={{ flex: 1, textAlign: "left", whiteSpace: "nowrap" }}>{value || `${label} wählen`}</span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .15s", flexShrink: 0 }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && (
        <div style={{ border: `1px solid ${c.border}`, borderTop: "none", borderRadius: "0 0 8px 8px", overflow: "hidden", marginBottom: 4 }}>
          {value && (
            <div onClick={onClear} style={{ padding: "8px 14px", fontSize: 12, cursor: "pointer", color: c.textSecondary, background: c.bg, borderBottom: `1px solid ${c.border}` }}>
              ✕ Auswahl aufheben
            </div>
          )}
          {children}
        </div>
      )}
    </div>
  );
}
